import appSettings from "../../views/appSettings/settings.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";
  const base = "settings";
  const params = ["page", "limit"];
  $stateProvider.state("settings", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appSettings,
      },
    },
    reloadOnSearch: false,
    data: { title: "Settings" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/settings/settings.urls.js